import StoreIcon from "@material-ui/icons/Store";
import GuaranteeTypeList from "./GuaranteeTypeList";

export default {
  list: GuaranteeTypeList,
  icon: StoreIcon,
};
